var map = {
	"./img/background.png": "b874",
	"./img/icon-borrow-egt.png": "19a5",
	"./img/icon-borrow-eth.png": "bcdd",
	"./img/icon-borrow.png": "34df",
	"./img/icon-bscegt.png": "0d23",
	"./img/icon-buy.png": "75bd",
	"./img/icon-calculator.png": "d409",
	"./img/icon-community.png": "af6c",
	"./img/icon-deposit.png": "120d",
	"./img/icon-eth.png": "e573",
	"./img/icon-game.png": "ab67",
	"./img/icon-logo.png": "3d9a",
	"./img/icon-registry.png": "75bb",
	"./img/icon-sell.png": "03e5",
	"./img/icon-twd.svg": "7b76",
	"./img/icon-usdt.png": "5a23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72b0";